// @flow
import FeaturedProperties from "./FeaturedProperties";

export default FeaturedProperties;
